import { useQuery } from '@tanstack/react-query';
import { STALE_TIME } from 'infrastructure/consts/stale-time';
import { showResult } from 'infrastructure/hooks/utils';
import dataService from 'services/dataService';

import type { IPatientCallInfo } from 'infrastructure/interfaces';

export const api = (patientGuid: string) =>
  `core-2/patients/${patientGuid}/call-info`;

interface Props {
  patientGuid?: string;
}

export const usePatientCallInfo = ({ patientGuid }: Props) => {
  const { data: callInfo, isFetching } = useQuery({
    queryKey: ['usePatientCallInfo', patientGuid],
    queryFn: async () => {
      const { data, error } = await dataService.getOnly<IPatientCallInfo>(
        api(patientGuid!),
      );

      if (error) {
        showResult(error);
        throw new Error(error);
      }

      return data;
    },
    staleTime: STALE_TIME,
    enabled: Boolean(patientGuid),
  });

  return {
    data: callInfo,
    isFetching,
  };
};
